import React, { useState } from 'react';
import './Condenser.css';
import axios from 'axios';

function Condenser() {
  const [url, setUrl] = useState('');

  const [result, setResult] = useState('');
  const [Status, setStatus] = useState('Condense');

  const handleShorten = async () => {
    if (!url) return;
    try {
      setStatus("Condensing..")
      const response = await axios.post(process.env.REACT_APP_CONDENSER,
        {
          longUrl: url
        },
        {
          headers: {
            "Content-type": "application/json"
          }
        });

      // Be careful while debugging, server caches all values
      if (response?.data?.length != 0)
        setResult(`${window.location.href}${response.data}`);

      else {
        setResult("Try again later");
      }
    } catch (err) {
      setResult("Try again later");
    }
    setStatus("Condense");
  };

  return (
    <>
      <div className="apple-container">
        <div className="card-wrapper">
          <h1>Condense..</h1>
          <p>A more elegant way to share.</p>

          <div className="input-glass-group">
            <input
              type="url"
              placeholder="https://example.com/url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
            <button className="btn-primary" onClick={handleShorten}>{Status}</button>
          </div>
          {result && (
            <div className="result-card">
              <span className="short-link">{result}</span>
              <button
                className="btn-secondary"
                onClick={() => {
                  navigator.clipboard.writeText(result);
                  setResult("copied!!");
                }}
              >Copy</button>
            </div>
          )}
        </div>
      </div>
      <center style={{
        position: "fixed",
        bottom: "0",
        margin: "auto",
        left: "50%",
        transform: "translateX(-50%)"
      }}>
        <p style={{ fontSize: "0.9rem" }}>© Copyrights {new Date().getFullYear()} nfrac-vtc, all rights reserved &nbsp;&nbsp; </p>
      </center >
    </>
  );
}

export default Condenser;